import CryptoJS from 'crypto-js/crypto-js'
import md5 from 'js-md5';

// 默认的加密 KEY 
const KEY_EN = CryptoJS.enc.Utf8.parse("xPxo2S5uGPhKHx5g");

// 排序key
const KET_SORT = 'hyfr6iyPZMZfJFEc'

const IV = CryptoJS.enc.Utf8.parse('0a1b2c3d4e5f6789');

/**
 * 按照对象key排序 a-z
 * @param {Object} dt 
 * @returns 
 */
export function objKeySort(dt) {
  const obj = {
    ...dt,
    k: KET_SORT
  };

  var newkey = Object.keys(obj).sort();
  var newObj = {};
  for (var i = 0; i < newkey.length; i++) {
    newObj[newkey[i]] = obj[newkey[i]];
  }
  return md5(JSON.stringify(newObj));
}

/**
 * 生成加密参数
 * @param {String} method 
 * @param {Object} data 
 * @returns 
 */
export function encryptParam(dt) {
  const data = {
    ...dt,
    s: objKeySort(dt)
  };
  return data ? Encrypt(JSON.stringify(data)) : data;
}

/**
 * AES加密 ：字符串 key iv  返回base64 
 */
export function Encrypt(word, keyStr, ivStr) {
  let key = KEY_EN
  let iv = IV

  if (keyStr) {
    key = CryptoJS.enc.Utf8.parse(keyStr);
    iv = CryptoJS.enc.Utf8.parse(ivStr);
  }

  let srcs = CryptoJS.enc.Utf8.parse(word);
  var encrypted = CryptoJS.AES.encrypt(srcs, key, {
    iv: iv, // 定义偏移量
    mode: CryptoJS.mode.CBC, // 定义加密模式
    padding: CryptoJS.pad.Pkcs7 // 定义填充
  })
  return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
}
/**
 * AES 解密 ：字符串 key iv  返回base64  
 */
export function Decrypt(word, keyStr, ivStr) {
  let key = KEY_EN
  let iv = IV

  if (keyStr) {
    key = CryptoJS.enc.Utf8.parse(keyStr);
    iv = CryptoJS.enc.Utf8.parse(ivStr);
  }

  let base64 = CryptoJS.enc.Base64.parse(word);
  let src = CryptoJS.enc.Base64.stringify(base64);

  var decrypt = CryptoJS.AES.decrypt(src, key, {
    iv: iv, // 定义偏移量
    mode: CryptoJS.mode.CBC, // 定义加密模式
    padding: CryptoJS.pad.Pkcs7 // 定义填充
  });
  var decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
  return decryptedStr.toString();
}